<template>
  <div class="list">
    <el-form :model="dioForm" label-width="auto">
      <el-form-item
        v-for="item in baseArray"
        :key="item.key"
        :label="$t(item.text)"
      >
        <template
          v-if="
            item.key === 'type' ||
              item.key === 'configStatus' ||
              item.key === 'status'
          "
        >
          <span>{{ textChange(item.key, item.content) }}</span>
        </template>
        <template v-else-if="item.key === 'description' && isMode">
          <el-input
            type="textarea"
            v-model="areaValue"
            maxlength="250"
            :autosize="{ minRows: 2, maxRows: 4 }"
            style="width: 300px"
            show-word-limit
          ></el-input>
        </template>
        <template v-else-if="item.key === 'nickname' && isMode">
          <el-input
            type="text"
            v-model="nickname"
            maxlength="30"
            style="width: 300px"
          ></el-input>
        </template>
        <span v-else>
          {{ item.content }}
        </span>
      </el-form-item>
      <el-form-item v-if="isMode">
        <el-button type="primary" @click="saveDecFn">
          <i class="el-icon-folder-checked button-icon "></i>
          {{ $t('public.save') }}
        </el-button>
        <el-button type="primary" @click="goBack"
          ><i class="el-icon-refresh-left button-icon"></i
          >{{ $t('integration.back') }}
        </el-button>
      </el-form-item>
      <el-form-item v-if="!isMode">
        <el-button type="primary" @click="goBack"
          ><i class="el-icon-edit button-icon"></i>{{ $t('public.edit') }}
        </el-button>
      </el-form-item>
      <!-- <slot></slot> -->
    </el-form>
  </div>
</template>

<script>
import { magnetismType } from '@/utils/convert.js'
export default {
  props: ['baseMsg', 'isMode'],
  data () {
    return {
      dioForm: {},
      baseArray: [],
      /** 配置状态 */
      configIconArray: [
        {
          value: 0,
          icon: 'el-icon-set-up',
          label: this.$t('device.wait_config')
        },
        {
          value: 1,
          icon: 'el-icon-connection',
          label: this.$t('device.configuring')
        },
        {
          value: 2,
          icon: 'el-icon-odometer',
          label: this.$t('device.configured')
        }
      ],
      /** 状态 */
      statusIcon: [
        {
          value: 0,
          icon: 'iconfont icon-wifi',
          label: $t('public.offline')
        },
        {
          value: 1,
          icon: 'iconfont icon-wu-WiFi',
          label: $t('public.online')
        },
        {
          value: 2,
          icon: 'el-icon-video-play',
          label: $t('public.stop')
        }
      ],
      // 详情

      nickname: '',
      areaValue: ''
    }
  },
  created () {
    this.baseArray = [...this.baseMsg]
  },
  methods: {
    textChange (key, value) {
      if (key === 'configStatus') {
        if (!value && value !== 0) {
          return '--'
        }
        return this.TOODChange(value, this.configIconArray)
      } else if (key === 'type') {
        if (!value) {
          return ''
        }
        return this.$t(magnetismType[value].title)
      } else {
        return this.TOODChange(value, this.statusIcon)
      }
    },
    TOODChange (value, array) {
      var param = ''
      for (const item of array) {
        if (item.value === value) {
          param = item.label
          break
        }
      }
      return param
    },
    goBack () {
      this.baseArray.forEach(item => {
        if (item.key === 'nickname') {
          this.nickname = item.content
        }
        if (item.key === 'description') {
          this.areaValue = item.content
        }
      })
      this.$emit('update:isMode', !this.isMode)
    },
    saveDecFn () {
      this.$emit('saveDecFn', {
        nickname: this.nickname,
        areaValue: this.areaValue
      })
      //   sensorUpdateSensor({
      //     id: this.detailObj.id,
      //     description: this.areaValue
      //   })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  flex: 1;
}

::v-deep .button-icon {
  margin: 0;
  color: white;
  font-size: 14px;
  font-weight: 100;
  margin-right: 5px;
}
</style>
